import { useEffect, useRef, useState } from 'react';
import { prepareIntakePhoto } from '@/utils/intakePhoto';

export default function IntakePhoto({value, onChange, label, lang, onBusy}) {
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const generation = useRef(0);
  useEffect(() => () => { generation.current++; }, []);
  async function choose(event) {
    const file = event.target.files?.[0]; event.target.value = '';
    if (!file) return;
    const id = ++generation.current; setBusy(true); onBusy?.(true); setError('');
    try { const photo = await prepareIntakePhoto(file); if (id === generation.current) onChange(photo); }
    catch (e) { if (id === generation.current) setError(e.message); }
    finally { if (id === generation.current) setBusy(false); onBusy?.(false); }
  }
  return <div className="space-y-2">
    {value && <div><img src={value} alt={label} className="max-h-64 rounded-xl border border-gray-200" />
      <button type="button" disabled={busy} onClick={() => onChange(null)} className="text-red-700 underline">{lang === 'es' ? 'Quitar foto' : 'Remove photo'}</button></div>}
    <div className="flex gap-3">
      {[true, false].map(camera => <label key={String(camera)} className="flex-1 rounded-xl border-2 border-dashed border-gray-300 p-4 text-center">
        {camera ? (lang === 'es' ? 'Tomar foto' : 'Take photo') : (lang === 'es' ? 'Elegir foto' : 'Choose photo')}
        <input type="file" accept="image/*" capture={camera ? 'environment' : undefined} disabled={busy} onChange={choose} className="block w-full text-sm" />
      </label>)}
    </div>
    <p className="text-sm text-gray-600" role="status">{busy ? 'Preparing photo…' : 'Photos are resized before saving. Check that all text is readable in the preview.'}</p>
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
  </div>;
}
